import React, { useState } from "react";
import {
  ConfigProvider,
  Modal,
  Input,
  Upload,
  Button,
  Form,
  notification,
  message,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import CoaService from "../../../features/CoaView/services/CoaService";
import TemplateService from "../../../features/TemplateView/services/TemplateService";
import { darkFormTheme, MODAL_STYLES, MODAL_TITLE_STYLE } from "../../../styles/modalStyles";
import { useNavigate } from "react-router-dom";
import {
  COA_CREATED_MESSAGE,
  COA_NAME_LABEL,
  CREATE_COA_BUTTON_LABEL,
  CREATE_TEMPLATE_BUTTON_LABEL,
  TEMPLATE_CREATED_MESSAGE,
  TEMPLATE_NAME_LABEL,
  TOAST_DEFAULT_ERROR_MESSAGE,
} from "../../utils/CommonConstants";

interface CreateModalProps {
  isVisible: boolean;
  isTemplate: boolean;
  fetchData: (currentPage: any, pageSize: any) => {};
  onCancel: () => void;
}

export const CreateModal: React.FC<CreateModalProps> = ({
  isVisible,
  isTemplate,
  fetchData,
  onCancel,
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const coaService = new CoaService();
  const templateService = new TemplateService();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const navigate = useNavigate();

  const handleFinish = async (values: any) => {
    const { name, file } = values;
    const selectedFile = file[0]?.originFileObj;

    if (!selectedFile) {
      notification.error({ message: "Please attach a file" });
      return;
    }

    setIsLoading(true);

    try {
      if (isTemplate) {
        await templateService.createTemplate(name, selectedFile);
        message.success(TEMPLATE_CREATED_MESSAGE);
        fetchData(0, 10);
      } else {
        await coaService.createCoA(name, selectedFile);
        message.success(COA_CREATED_MESSAGE);
      }
    } catch (error) {
      notification.error({ message: TOAST_DEFAULT_ERROR_MESSAGE });
    } finally {
      setIsLoading(false);
      form.resetFields();
      onCancel();
    }
  };
  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };
  return (
    <Modal
      title={
        <span style={MODAL_TITLE_STYLE}>
          {isTemplate ? CREATE_TEMPLATE_BUTTON_LABEL : CREATE_COA_BUTTON_LABEL}
        </span>
      }
      open={isVisible}
      onCancel={handleCancel}
      footer={null}
      styles={MODAL_STYLES}
    >
      <ConfigProvider theme={darkFormTheme}>
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <Form.Item
          label={isTemplate ? TEMPLATE_NAME_LABEL : COA_NAME_LABEL}
          name="name"
          rules={[
            {
              required: true,
              message: isTemplate
                ? "Please enter Template Name"
                : "Please enter Coa Name",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Attach File"
          name="file"
          valuePropName="fileList"
          getValueFromEvent={(e) => (Array.isArray(e) ? e : e?.fileList)}
          rules={[{ required: true, message: "Please attach a File" }]}
        >
          <Upload maxCount={1} accept=".xlsx,.xlsm" beforeUpload={() => false}>
            <Button id="select-file" icon={<UploadOutlined />}>Select File</Button>
          </Upload>
        </Form.Item>
        <div className="flex gap-2 w-full">
          <Button id="cancel-create" type="default" block onClick={handleCancel}>
            Cancel
          </Button>
          <Button id="submit-create" type="primary" htmlType="submit" block loading={isLoading}>
            Create
          </Button>
        </div>
      </Form>
      </ConfigProvider>
    </Modal>
  );
};
